import TYPES from '../../types';

// Domain
import { JobTypeEntity } from '../../domain/entities/job-type-entity';
import { JobTypeRepository } from '../../domain/repository/job-type-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchJobTypesQuery extends Query<Promise<Array<JobTypeEntity>>> {
  @Inject(TYPES.CATALOG_KUSPIT_JOB_TYPE_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_KUSPIT_JOB_TYPE_REPOSITORY)
  private readonly repository!: JobTypeRepository;

  internalExecute(): Promise<Array<JobTypeEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
